"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const pageContext = (0, react_1.createContext)(null);
exports.default = pageContext;
